import {
  CaptureProfileClient,
  CaptureProfileDTO,
  DropImageSettingsDTO,
  ProfileDTO,
  SaveCaptureProfilesDTO,
  SaveRegionCaptureProfilesDTO,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import { getPlainRegionCaptureProfileDTO } from 'transformers/experiment';

export default class CaptureProfileService extends BaseService {
  async getCaptureProfile() {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.getCaptureProfile();
  }

  async getImageSettings() {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.getAllCaptureProfilesWithImageSettings();
  }

  async saveCaptureProfile(saveCaptureProfiles: SaveCaptureProfilesDTO) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.saveCaptureProfiles(saveCaptureProfiles);
  }

  async getCaptureProfileByName(
    cpName: string,
    includeFlags?: boolean,
  ): Promise<ProfileDTO> {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    const cpDTO: CaptureProfileDTO = await captureProfileClient.getCaptureProfile();

    let capProfile: ProfileDTO[] = [];
    if (cpDTO?.captureProfileRows.length) {
      capProfile = cpDTO.captureProfileRows.filter((cp) => cp.name === cpName);

      if (capProfile?.length) {
        return capProfile[0];
      }
    }

    return null;
  }
  async getRegionCaptureProfilesByRegionId(regionId: number) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.getRegionCaptureProfilesByRegionID(regionId);
  }
  async saveRegionCaptureProfiles(regionCaptureProfiles: SaveRegionCaptureProfilesDTO) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.saveRegionCaptureProfiles(regionCaptureProfiles);
  }
  async updateRegionCaptureProfile(dropImageSettingsDTOList: DropImageSettingsDTO[]) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    const response = await captureProfileClient.updateRegionCaptureProfile(
      dropImageSettingsDTOList,
    );
    return getPlainRegionCaptureProfileDTO(response);
  }

  async getCaptureProfileById(cpId: number) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.getCaptureProfileById(cpId);
  }

  async getIsFrapCaptureProfile(cpId: number) {
    const captureProfileClient: CaptureProfileClient = ModelFactory(
      CaptureProfileClient,
      false,
      true,
    );
    return await captureProfileClient.getIsFrapCaptureProfile(cpId);
  }
}
